<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">SEO</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'seo-images'}">Images</router-link></li>
        <li class="breadcrumb-item active">Edit record {{ record.id }}</li>
      </ol>
    </div>
    <form action="/api/admin/seo/save" method="POST" @submit.prevent="saveRecord()">
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Edit image meta</h3>
          <div class="form-group">
            <img :src="record.image_src" style="max-width:100%;" >
          </div>
          <div class="form-group">
            <label>URL</label>
            <input v-model.trim="record.image_src" :readonly="true" class="form-control" >
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Pages</h3>
          <p>{{ (record.url || []).join(', ') }}</p>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Attributes</h3>
          <div class="form-group">
            <label>Class</label>
            <input v-model.trim="record.attributes.class" class="form-control" >
          </div>
          <div class="form-group">
            <label>Alt</label>
            <textarea v-model.trim="record.attributes.alt" class="form-control"/>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* global axios, toastr */
export default {
  name: 'SeoImageEdit',
  data () {
    return {
      record: {
        attributes: {}
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    let route = '/api/admin/seo/image/' + to.params.imageId
    axios
      .get(route)
      .then(repsonse => {
        next(vm => (vm.record = repsonse.data.image))
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  methods: {
    saveRecord () {
      axios
        .post('/api/admin/seo/image/save', {
          image: this.record
        })
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            this.record = response.data.image
            toastr['success']('Changes have been saved successfully')
          } else {
            let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
            toastr['error'](message)
          }
        })
        .catch(error => {
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    },
    goBack () {
      this.$router.push('/admin/seo/images')
    }
  }
}
</script>

<style>
</style>
